import { render, staticRenderFns } from "./ProductSearchBlock.vue?vue&type=template&id=68d05bbc&"
import script from "./ProductSearchBlock.vue?vue&type=script&lang=js&"
export * from "./ProductSearchBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/myraj/m247/git/landing-pages/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d05bbc')) {
      api.createRecord('68d05bbc', component.options)
    } else {
      api.reload('68d05bbc', component.options)
    }
    module.hot.accept("./ProductSearchBlock.vue?vue&type=template&id=68d05bbc&", function () {
      api.rerender('68d05bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/ProductSearchBlock.vue"
export default component.exports